import { render, staticRenderFns } from "./OptTradeDetail.vue?vue&type=template&id=d4617b24"
import script from "./OptTradeDetail.vue?vue&type=script&lang=js"
export * from "./OptTradeDetail.vue?vue&type=script&lang=js"
import style0 from "./OptTradeDetail.vue?vue&type=style&index=0&id=d4617b24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports